import { css } from '@fable/theme'

export const getInsightText = (text: string, highlight: string) => {
  const splitText = text.split(/\*\*(.*?)\*\*/)

  const formattedText = splitText.map((part, index) => {
    if (index % 2 === 0) {
      return <span key={index}>{part}</span>
    } else {
      return (
        <span
          key={index}
          className={css`
            color: ${highlight};
          `}
        >
          {part}
        </span>
      )
    }
  })

  return formattedText
}
